// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Form, Image, Checkbox } from "semantic-ui-react";
import { isEmpty, find } from "lodash";

// Components
import Input from "@Components/Input";

// Utils
import { phoneFormat } from "@Utils/formats";

// subComponents
import { Facebook, Telegram, Twitter, Whatsapp, Instagram, Personal } from "@Assets/index";
import InfoBox from "../InfoBox";

// Styles
import styles from "./styles.module.css";

const ImageChannel = (channelName = "") => {
	switch (channelName.toLowerCase()) {
		case "whatsapp":
			return <Image src={Whatsapp} className={styles.channelImagen} />;
		case "twitter":
			return <Image src={Twitter} className={styles.channelImagen} />;
		case "facebook":
			return <Image src={Facebook} className={styles.channelImagen} />;
		case "telegram":
			return <Image src={Telegram} className={styles.channelImagen} />;
		case "instagram":
			return <Image src={Instagram} className={styles.channelImagen} />;
		case "personal":
			return <Image src={Personal} className={styles.channelImagen} />;
		default:
			return <Image src="https://react.semantic-ui.com/images/wireframe/image.png" className={styles.channelImagen} />;
	}
};

const StaticFieldCard = ({
	isEditable = true,
	contactInfo = { name: "", phone: "", email: "", channel: "", isBlocked: false },
	setContactInfo = () => {},
	errors = {},
	phoneEdit = true,
	showChannel = false,
	disabledStyle = false,
	contactFields = [
		{ label: "name", isEditable: true, isRequired: false },
		{ label: "phone", isEditable: true, isRequired: false },
		{ label: "email", isEditable: true, isRequired: false },
	],
	contactData,
	noDisableStaticFields = false,
	highlightBlocked = false,
}) => {
	const inputsHandler = (e, { name: inputName, value, checked }) => {
		const nextValue = typeof checked !== "undefined" ? checked : value;
		setContactInfo({ ...contactInfo, [inputName]: nextValue });
	};

	const getFieldSetting = (field = "name", setting = "isEditable") => {
		const contactField = find(contactFields, { label: field });

		if (isEmpty(contactField)) return true;
		if (setting === "isEditable") {
			if (noDisableStaticFields) {
				return true;
			}
			if (contactField[setting] === false) {
				if (isEmpty(contactData[field])) {
					return true;
				}
				return false;
			}
			return true;
		}

		return contactField[setting] || false;
	};

	// const isPhoneLockedByChannel = includes(["whatsapp", "personal", "whatsapp360"], contactInfo.channel?.toLowerCase());
	const isPhoneLockedByChannel = false;
	const isContactBlocked = Boolean(contactInfo?.isBlocked);

	return (
		<InfoBox title="Contacto" toggleable defaultToggleOpen disabled={disabledStyle}>
			<Form>
				{showChannel && (
					<div className={styles.containerPlatform}>
						<Input
							fluid
							disabled
							className={`${styles.input} ${disabledStyle ? styles.disabledStyle : ""}`}
							label="Plataforma"
							placeholder="Plataforma de contacto"
							name="channel"
							value={contactInfo.channel}
							onChange={inputsHandler}
						/>
						{ImageChannel(contactInfo.channel)}
					</div>
				)}

				<div className={!getFieldSetting("name", "isEditable") ? styles.inputNoEditableContainer : ""}>
					<Input
						fluid
						disabled={!isEditable || !getFieldSetting("name", "isEditable")}
						className={`${styles.input} ${disabledStyle ? styles.disabledStyle : ""} ${
							!getFieldSetting("name", "isEditable") ? styles.inputNoEditable : ""
						} ${isContactBlocked ? styles.blockedInput : ""}`}
						icon="user"
						required={getFieldSetting("name", "isRequired")}
						placeholder="Nombre"
						error={!isEmpty(errors.name) && { content: errors.name, pointing: "above" }}
						name="name"
						label="Nombre"
						value={contactInfo.name}
						onChange={inputsHandler}
					/>
				</div>
				<div
					className={
						!getFieldSetting("phone", "isEditable") || isPhoneLockedByChannel || !phoneEdit ? styles.inputNoEditableContainer : ""
					}>
					<Input
						fluid
						disabled={!isEditable || !phoneEdit || isPhoneLockedByChannel || !getFieldSetting("phone", "isEditable")}
						className={`${
							!phoneEdit || isPhoneLockedByChannel || !getFieldSetting("phone", "isEditable") ? styles.inputNoEditable : styles.input
						} ${disabledStyle ? styles.disabledStyle : ""}`}
						icon="phone"
						label="Teléfono"
						placeholder="Teléfono"
						error={!isEmpty(errors.phone) && { content: errors.phone, pointing: "above" }}
						name="phone"
						value={phoneFormat(contactInfo.phone)}
						onChange={inputsHandler}
						required={getFieldSetting("phone", "isRequired")}
					/>
				</div>
				<div className={styles.emailRow}>
					<Input
						fluid
						icon="mail"
						label="Email"
						placeholder="Correo Electrónico"
						required={getFieldSetting("email", "isRequired")}
						disabled={!isEditable || !getFieldSetting("email", "isEditable")}
						error={!isEmpty(errors.email) && { content: errors.email, pointing: "above" }}
						name="email"
						value={contactInfo.email}
						onChange={inputsHandler}
						className={`${styles.input} ${disabledStyle ? styles.disabledStyle : ""} ${
							!getFieldSetting("email", "isEditable") ? styles.inputNoEditable : ""
						}`}
					/>

					{highlightBlocked && (
						<Form.Field className={styles.blockToggleField}>
							<label className={styles.blockToggleLabel}>Bloquear</label>
							<div className={styles.blockToggleWrapper}>
								<Checkbox
									toggle
									name="isBlocked"
									checked={Boolean(contactInfo.isBlocked)}
									onChange={(e, data) => {
										return inputsHandler(e, { ...data, value: data.checked });
									}}
									disabled={!isEditable}
								/>
								<span className={styles.blockToggleStatus}>{isContactBlocked ? "Sí" : "No"}</span>
							</div>
						</Form.Field>
					)}
				</div>
			</Form>
		</InfoBox>
	);
};

StaticFieldCard.propTypes = {
	isEditable: PropTypes.bool,
	phoneEdit: PropTypes.bool,
	contactInfo: PropTypes.object,
	contactData: PropTypes.object,
	errors: PropTypes.object,
	setContactInfo: PropTypes.func,
	showChannel: PropTypes.bool,
	disabledStyle: PropTypes.bool,
	noDisableStaticFields: PropTypes.bool,
	contactFields: PropTypes.array,
	highlightBlocked: PropTypes.bool,
};

export default StaticFieldCard;
